import { JsonSerializable } from '../shared/jsonSerializable';

export class Address  extends JsonSerializable {

  address1: string;
  address2: string;
  postalCode: string;
  city: string;
  isDefault: boolean;

  constructor() {
    super();
    this.address1 = null;
    this.address2 = null;
    this.postalCode = null;
    this.city = null;
    this.isDefault = false;
  }




}


// WEBPACK FOOTER //
// ./src/app/entity/address.ts